import { motion } from "framer-motion";
import "./components/Start.css";

export default function StartPage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="w-full h-screen flex justify-center bg-chart"
    >
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="w-full gap-6 flex flex-col items-center px-6 py-10 text-center">
          <img
            src="/icon7.png"
            alt="example"
            width={100}
            height={100}
            className="rounded-2xl"
          />

          <h1 className="text-4xl font-semibold text-blue-600 ">7 Trade</h1>

          <p className="text-gray-700 text-sm mt-6 leading-6">
            Add the 7 Trade web app to your mobile home screen
          </p>

          <div className="flex items-center justify-start w-full gap-3">
            <div className="w-10 h-10 rounded-full border flex items-center cursor-pointer justify-center flex-shrink-0">
              <svg
                className="w-5 h-5 text-gray-700 "
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 12v7a1 1 0 001 1h3m10-8V5a1 1 0 00-1-1h-3m-4 8l4-4m0 0l-4-4m4 4H3"
                />
              </svg>
            </div>
            <div className="text-left">
              <p className="text-sm font-medium">Share</p>
              <p className="text-xs text-gray-500">Select this option from the bottom bar</p>
            </div>
          </div>

          <div className="flex items-center justify-start w-full gap-3">
            <div className="w-10 h-10 rounded-full border flex items-center cursor-pointer justify-center flex-shrink-0">
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </div>
            <div className="text-left">
              <p className="text-sm font-medium">Add to homescreen</p>
              <p className="text-xs text-gray-500">Select this option from the menu shown</p>
            </div>
          </div>

          <div className="w-full flex justify-start gap-3">
            <button className="cursor-pointer bg-blue-600 text-white flex w-10 h-10 items-center justify-center rounded-full shadow-md flex-shrink-0">
              <img
                src="/7.png"
                alt="example"
                width={10}
                height={10}
                className="w-full flex justify-center items-center rounded-full cursor-pointer"
              />
            </button>
            <div className="text-left">
              <p className="text-sm font-medium">Add</p>
              <p className="text-xs text-gray-500">Tap this option</p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}